import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import { faPlay } from "@fortawesome/pro-solid-svg-icons";

import { FunctionComponent, useState } from "react";

import ReactDOM from "react-dom";
import ReactPlayer from "react-player";

import { Icon } from "../Icon/Icon";

type StepInfoProps = {
	title: string;
	description: JSX.Element | string;
	videoId?: string;
};

export const StepInfo: FunctionComponent<StepInfoProps> = ({ title, description, videoId }) => {
	const [showVideo, setShowVideo] = useState(false);

	return (
		<>
			<div className="flex flex-row w-full items-start bg-light-blue border border-action-400 p-4 px-5 mb-6 rounded-xl gap-4">
				<Icon className="text-brand-light w-5 h-5 mt-0.5 flex-shrink-0" icon={faInfoCircle} />
				<div className="flex-1 flex flex-col gap-1">
					<div className="text-sm text-text font-semibold">{title}</div>
					<div className="text-sm text-gray-700 leading-relaxed">{description}</div>
				</div>
				{videoId && (
					<button
						className="flex-shrink-0 flex items-center gap-2 bg-white border border-border-light rounded-lg px-3.5 py-2 text-xs font-medium text-gray-700 hover:border-brand-light hover:text-brand-light transition-all duration-150 cursor-pointer"
						onClick={() => setShowVideo(true)}
					>
						<Icon className="w-3 h-3" icon={faPlay} />
						Watch tutorial
					</button>
				)}
			</div>
			{showVideo &&
				videoId &&
				ReactDOM.createPortal(
					<div
						className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10001]"
						onClick={() => setShowVideo(false)}
					>
						<div className="w-1/2 aspect-video" onClick={(e) => e.stopPropagation()}>
							<ReactPlayer
								className="w-full h-full"
								controls={true}
								src={`https://www.youtube.com/watch?v=${videoId}`}
								style={{ width: "100%", height: "100%" }}
							/>
						</div>
					</div>,
					document.body
				)}
		</>
	);
};
